import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);



export default function initNextSection() {
  const classActive = 'menu--opened';

  document.querySelectorAll('[data-next-section]').forEach((link)=> {
    const parent = link.closest('section') ;
    if(!parent) return;
    const target = parent.nextElementSibling;

    if(!target || target.tagName !== 'SECTION') return;

    link.addEventListener('click',(e)=> {
      e.preventDefault();
      if(window.lenis) {
        window.lenis.scrollTo(target,{
          duration: 1.5,
        })
      }
    });
  });

   document.querySelectorAll('a[href^="#"]').forEach((link)=> {
    link.addEventListener('click', (e)=> {
      const target = document.querySelector(link.getAttribute('href'));
      if(target) {
        if(window.lenis) {
          window.lenis.scrollTo(target,{
            duration: 1.5,
          });
        }
      }
      if(document.body.classList.contains(classActive)) {
        document.body.classList.remove(classActive);
      }
    })
   });
}